import { render, staticRenderFns } from "./IndexArticle.vue?vue&type=template&id=5d4271ae&scoped=true&"
import script from "./IndexArticle.vue?vue&type=script&lang=js&"
export * from "./IndexArticle.vue?vue&type=script&lang=js&"
import style0 from "./IndexArticle.vue?vue&type=style&index=0&id=5d4271ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4271ae",
  null
  
)

export default component.exports